import { FC } from "react";

export const ChartGradients: FC = () => (
  <>
    <linearGradient id="bar-gradient" gradientUnits="userSpaceOnUse" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stopColor="#FFDF76" />
      <stop offset="100%" stopColor="#FFF8DD" />
    </linearGradient>
    <linearGradient id="bar-single-gradient" gradientUnits="userSpaceOnUse" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stopColor="#FFDF76" stopOpacity={0.3} />
      <stop offset="100%" stopColor="#FFF8DD" stopOpacity={0.3} />
    </linearGradient>
    <filter id="area-filter-blue" x="0" y="0" width="100%" height="100%" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
      <feFlood floodOpacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="30"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.654902 0 0 0 0 0.964706 0 0 0 1 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5109_1066"/>
    </filter>
    <filter id="area-filter-green" x="0" y="0" width="100%" height="100%" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
      <feFlood floodOpacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="30"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.129412 0 0 0 0 0.745098 0 0 0 0 0.419608 0 0 0 1 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5109_2221"/>
    </filter>
  </>
);